<!-- 人数 -->
<template>
  <div class="row">
    <div class="th cell">人数</div>
    <!-- サルーン席の場合は、区分なしで合計人数のみ表示する -->
    <div v-if="!isSaloon" class="cell">
      おとな{{ adult }}名/こども{{ child }}名
    </div>
    <div v-else class="cell">{{ adult + child }}名</div>
  </div>
</template>

<script>
export default {
  name: "StorePassenger",
  props: {
    adult: {
      type: Number,
      required: true,
    },
    child: {
      type: Number,
      required: true,
    },
    // サルーン席の場合は、区分なしで合計人数のみ表示する
    isSaloon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  display: table;
  font-size: 13px;
}
.row {
  display: table-row;
}

.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
  padding-right: 14px;
}
.arrow {
  width: 10px;
  height: auto;
  padding: 0 6px 1px 6px;
}
</style>
